export const triggerTransmitPdfDownload = (
  previewUrl: string,
  fileName = 'transmit.pdf',
) => {
  const anchor = document.createElement('a');
  anchor.href = previewUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

export const logAndDownloadTransmitPdf = async ({
  previewUrl,
  fileName,
  logDownload,
}: {
  previewUrl: string;
  fileName?: string;
  logDownload?: () => Promise<unknown>;
}) => {
  if (logDownload) {
    await logDownload();
  }

  triggerTransmitPdfDownload(previewUrl, fileName);
};
